var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlowchat01(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 412,
    height: 31,
    viewBox: "0 0 412 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.597
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Button - Outline"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 334",
    transform: "translate(338)",
    style: {
      stroke: "#353d45",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 74,
    height: 31,
    rx: 15,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 73,
    height: 30,
    rx: 14.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(353 21)",
    style: {
      fontSize: 14,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC",
      fill: "#353d45"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "XE")), _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    y: 0
  }, "\u7CFB\u7D71")))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Button - Outline"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 334",
    transform: "translate(106)",
    style: {
      stroke: "#353d45",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 31,
    rx: 15,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 30,
    rx: 14.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": 1,
    transform: "translate(121 21)",
    style: {
      fontSize: 14,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC",
      fill: "#353d45"
    }
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "1")))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Button - Outline"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 334",
    transform: "translate(164)",
    style: {
      stroke: "#353d45",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 31,
    rx: 15,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 30,
    rx: 14.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": 2,
    transform: "translate(179 21)",
    style: {
      fontSize: 14,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC",
      fill: "#353d45"
    }
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "2")))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Button - Outline"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 334",
    transform: "translate(222)",
    style: {
      stroke: "#353d45",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 31,
    rx: 15,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 30,
    rx: 14.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": 3,
    transform: "translate(237 21)",
    style: {
      fontSize: 14,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC",
      fill: "#353d45"
    }
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "3")))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Button - Outline"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 334",
    transform: "translate(280)",
    style: {
      stroke: "#353d45",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 31,
    rx: 15,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 37,
    height: 30,
    rx: 14.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    "data-name": 4,
    transform: "translate(295 21)",
    style: {
      fontSize: 14,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC",
      fill: "#353d45"
    }
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "4")))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Button - Outline"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 334",
    style: {
      fill: "#353d45",
      stroke: "#353d45"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    width: 86,
    height: 31,
    rx: 15,
    style: {
      stroke: "none"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 85,
    height: 30,
    rx: 14.5,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("text", {
    transform: "translate(15 21)",
    style: {
      fill: "#fff",
      fontSize: 14,
      fontFamily: "NotoSansCJKtc-Regular,Noto Sans CJK TC"
    }
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\u5C0E\u5165\u7CBE\u9748")))), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8581",
    transform: "translate(318 14)",
    style: {
      fill: "#353d45"
    },
    d: "M0 0h20v1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8646",
    transform: "translate(86 14)",
    style: {
      fill: "#353d45"
    },
    d: "M0 0h20v1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8647",
    transform: "translate(144 14)",
    style: {
      fill: "#353d45"
    },
    d: "M0 0h20v1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8648",
    transform: "translate(202 14)",
    style: {
      fill: "#353d45"
    },
    d: "M0 0h20v1H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 8649",
    transform: "translate(260 14)",
    style: {
      fill: "#353d45"
    },
    d: "M0 0h20v1H0z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowchat01);
export default __webpack_public_path__ + "static/media/flowchat01.3739404b26a9eba1acb104917ff6339c.svg";
export { ForwardRef as ReactComponent };